/*
 * Application-wide environment variable constants
 * Add these to the appropriate .env file (ex. use .env.local to override these locally)
 * NOTE: must prepend with 'REACT_APP_' in the .env files but will have that prefix stripped before being added to process.env
 */
export const {
  ENV,
  MAGENTO_API_HOST,
  TRANSACTIONAL_ITEMS_API_HOST,
  REGISTRY_SHOPPING_GRAPHQL_ENDPOINT,
  TK_HOST,
  MEDIA_API_STOCK_IMAGE,
  MEDIA_API_HOST,
  POPULAR_GIFTS_CATEGORY_EXCLUSIONS,
  POWER_REVIEWS_API_KEY,
  POWER_REVIEWS_MERCHANT_ID,
  POWER_REVIEWS_MERCHANT_GROUP_ID,
  REGISTRY_ITEM_GATEWAY_API_HOST,
  WEDDINGS_API_HOST,
} = process.env;

export const POPULAR_GIFTS_CATEGORY_EXCLUSIONS_IDS = POPULAR_GIFTS_CATEGORY_EXCLUSIONS.split(
  ',',
);
